import React from 'react'

function Banners({data}) {

    // following function will capitalize the first letter 
    function capitalize(s){
      return s && String(s[0]).toUpperCase() + String(s).slice(1);
}

function isEmpty(obj) {
  for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
          return false;
      }
  }
  return true; 
}

const banner1 = data.advertisement + '1080* 645'
const banner2 = data.advertisementHD + '1920 * 1080'
const banner3 = data.sliderAndText + '1920 * 590'
const banner4 = data.sliderNoText + '1920 * 590'
const banner5 = data.sliderSmall + '640 * 345 '


  return (
    <section style={{display:'',flexWrap:'wrap',}}>
     <div style={{display:'flex',justifyContent:'space-between'}}>
       {isEmpty(data.advertisement) === false ? 
       <div className='bannerContainer'>
          <img style={{width:'242px',objectFit:'cover',objectPosition:'center'}} src={`https://poster.ebillet.dk/advertisement/`+data.advertisement}  alt="" />
            <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Banner</p>
              <p style={{fontWeight:400,marginTop:'-4px',marginBottom:'10px'}}>{isEmpty(data.advertisement) === false ? capitalize(data.advertisement) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>1080 x 645 px</p>
            </div>
       </div>
       : ''}
         {isEmpty(data.advertisementHD) === false ? 
       <div className='bannerContainer'>
          <img style={{width:'242px',objectFit:'cover',objectPosition:'center'}} src={`https://poster.ebillet.dk/advertisement/`+data.advertisementHD}  alt="" />
            <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Banner</p>
              <p style={{fontWeight:400,marginTop:'-4px',marginBottom:'10px'}}>{isEmpty(data.advertisementHD) === false ? capitalize(data.advertisementHD) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>1920 x 1080 px</p>
            </div>
       </div>
       : ''}
      {isEmpty(data.sliderAndText) === false ? 
       <div className='bannerContainer'>
          <img style={{width:'242px',objectFit:'cover',objectPosition:'center'}} src={`https://poster.ebillet.dk/advertisement/`+data.sliderAndText}  alt="" />
            <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Banner</p>
              <p style={{fontWeight:400,marginTop:'-4px',marginBottom:'10px'}}>{isEmpty(data.sliderAndText) === false ? capitalize(data.sliderAndText) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>1920 x 590 px</p>
            </div>
       </div>
    : ''}
</div>
<div style={{display:'flex',justifyContent:'space-between',width:'65%',marginTop:'40px'}}>
      {isEmpty(data.sliderNoText) === false ? 
       <div className='bannerContainer' style={{marginRight:'50px'}}>
          <img style={{width:'242px',objectFit:'cover',objectPosition:'center'}} src={`https://poster.ebillet.dk/advertisement/`+data.sliderNoText}  alt="" />
            <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Banner</p>
              <p style={{fontWeight:400,marginTop:'-4px',marginBottom:'10px'}}>{isEmpty(data.sliderNoText) === false ? capitalize(data.sliderNoText) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>1920 x 590 px</p>
            </div>
       </div>
    : ''}
     {isEmpty(data.sliderSmall) === false ? 
       <div className='bannerContainer' >
          <img style={{width:'242px',objectFit:'cover',objectPosition:'center'}} src={`https://poster.ebillet.dk/advertisement/`+data.sliderSmall}  alt="" />
            <div style={{fontSize:'12px',marginTop:'15px'}}>
              <p style={{margin:0,fontWeight:700}}>Banner</p>
              <p style={{fontWeight:400,marginTop:'-4px',marginBottom:'10px'}}>{isEmpty(data.sliderSmall) === false ? capitalize(data.sliderSmall) : ''}</p>
              <p style={{margin:0,fontWeight:700}}>Størrelse</p>
              <p style={{fontWeight:400,marginTop:'-2px'}}>640 x 345 px</p>
            </div>
       </div>
    : ''}
    </div>
    </section>
  )
}

export default Banners